
import React from 'react';

interface MentionTextProps {
  children: string;
  className?: string;
  onMentionClick?: (username: string) => void;
}

export const MentionText = ({ children, className = '', onMentionClick }: MentionTextProps) => {
  const mentionRegex = /@(\w+)/g;
  
  const renderTextWithMentions = (text: string) => {
    if (!text) return text;
    
    const parts = [];
    let lastIndex = 0;
    let match;
    
    while ((match = mentionRegex.exec(text)) !== null) {
      // Add text before mention
      if (match.index > lastIndex) {
        parts.push(text.slice(lastIndex, match.index));
      }
      
      // Add mention as clickable element
      const username = match[1];
      parts.push(
        <button
          key={`mention-${match.index}`}
          onClick={() => onMentionClick?.(username)}
          className="text-blue-600 hover:text-blue-800 font-medium hover:underline focus:outline-none focus:underline"
        >
          @{username}
        </button>
      );
      
      lastIndex = match.index + match[0].length;
    }
    
    // Add remaining text
    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex));
    }
    
    return parts.length > 1 ? parts : text;
  };

  return (
    <span className={className}>
      {renderTextWithMentions(children)}
    </span>
  );
};
